module.exports = __webpack_public_path__ + "static/media/bg.a4be512e.png";